import dateFormat from '@/utils/dateFormat';

const columns = () => ([
  {
    title: 'Key',
    dataIndex: 'key',
    key: 'key',
    width: '20%',
  },
  {
    title: 'Created date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    customRender: ({ text }) => dateFormat(text, 'DD/MM/YYYY HH:MM'),
  },
  {
    title: 'Initial balance',
    dataIndex: 'initialBalance',
    key: 'initialBalance',
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    key: 'balance',
  },
  {
    title: 'Is Deleted',
    dataIndex: 'isDeleted',
    key: 'isDeleted',
    customRender: ({ text }) => (text ? 'Yes' : 'No'),
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: '15%',
  },
]);

export default columns;
